// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
  height: auto;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #5d7a48 #10160e;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track {
  background: #10160e;
}

html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb {
  background: #5d7a48;
  border-radius: 9999px;
}

html::-webkit-scrollbar-thumb:hover,
body::-webkit-scrollbar-thumb:hover {
  background: #8fb86a;
}

body {
  font-family: 'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  padding: 0;
  margin: 0;
  background-color: #10160e;
  background-image: repeating-linear-gradient(
    to bottom,
    transparent 0,
    transparent 2px,
    rgba(0, 0, 0, 0.08) 2px,
    rgba(0, 0, 0, 0.08) 3px
  );
  background-attachment: fixed;
  color: #d7e8c4;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #5d7a48 #10160e;
  text-shadow: 0 0 10px rgba(198, 232, 154, 0.18);
}

#root {
  min-height: 100vh;
}

a {
  color: inherit;
}

:focus-visible {
  outline: 2px solid #c6e89a;
  outline-offset: 2px;
}

@keyframes spinAnimation {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

#spinner {
  display: inline-block;
  color: #c6e89a;
  width: 20px;
  height: 20px;
  animation: spinAnimation 1s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }

  body {
    text-shadow: none;
    background-image: none;
  }

  #spinner {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/global.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,8FAA8F;EAC9F,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB;;;;;;GAMC;EACD,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["html {\n  scroll-behavior: smooth;\n  height: auto;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #5d7a48 #10160e;\n}\n\nhtml::-webkit-scrollbar,\nbody::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\nhtml::-webkit-scrollbar-track,\nbody::-webkit-scrollbar-track {\n  background: #10160e;\n}\n\nhtml::-webkit-scrollbar-thumb,\nbody::-webkit-scrollbar-thumb {\n  background: #5d7a48;\n  border-radius: 9999px;\n}\n\nhtml::-webkit-scrollbar-thumb:hover,\nbody::-webkit-scrollbar-thumb:hover {\n  background: #8fb86a;\n}\n\nbody {\n  font-family: 'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  padding: 0;\n  margin: 0;\n  background-color: #10160e;\n  background-image: repeating-linear-gradient(\n    to bottom,\n    transparent 0,\n    transparent 2px,\n    rgba(0, 0, 0, 0.08) 2px,\n    rgba(0, 0, 0, 0.08) 3px\n  );\n  background-attachment: fixed;\n  color: #d7e8c4;\n  min-height: 100vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #5d7a48 #10160e;\n  text-shadow: 0 0 10px rgba(198, 232, 154, 0.18);\n}\n\n#root {\n  min-height: 100vh;\n}\n\na {\n  color: inherit;\n}\n\n:focus-visible {\n  outline: 2px solid #c6e89a;\n  outline-offset: 2px;\n}\n\n@keyframes spinAnimation {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  50% {\n    transform: rotate(180deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n#spinner {\n  display: inline-block;\n  color: #c6e89a;\n  width: 20px;\n  height: 20px;\n  animation: spinAnimation 1s linear infinite;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto;\n  }\n\n  body {\n    text-shadow: none;\n    background-image: none;\n  }\n\n  #spinner {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
